import { resourceText } from 'src/app/shared/services/localization';
import { GoogleMapsService } from '../../address-check/google-maps.service';
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MemberLocation } from '../member-location.model';
import { MemberService } from '../../services/member.service';

@Component({
    selector: 'app-members-on-map',
    templateUrl: './members-on-map.component.html',
    styleUrls: ['./members-on-map.component.scss'],
    standalone: false
})
export class MembersOnMapComponent implements AfterViewInit {
  @ViewChild('map') mapElement: any;
  @Input() contactsArr: number[];
  memberLocArr: MemberLocation[];
  isLoading: boolean = true;
  map: google.maps.Map;
  currentPosition = {
    lat: 0,
    lng: 0,
  };

  mapError = '';
  constructor(private memberService: MemberService, private mapsService: GoogleMapsService) {}

  async ngAfterViewInit() {
    this.memberLocArr = await this.memberService.getMemberLocations(
      this.contactsArr
    );
    if (this.memberLocArr.length == 0) {
      this.isLoading = false;
      return;
    }

    this.isLoading = false;

    try {
      const maps = await this.mapsService.load();
      await maps.importLibrary('maps');
      await maps.importLibrary('marker');
    } catch { this.mapError = resourceText('UI_THE_MAP_COULD_NOT_LOAD_PLEASE_TRY_AGAIN_LATER'); return; }
    const mapProperties = {
      center: new google.maps.LatLng(
        this.currentPosition.lat == 0
          ? this.memberLocArr[0].latitude
          : this.currentPosition.lat,
        this.currentPosition.lng == 0
          ? this.memberLocArr[0].longitude
          : this.currentPosition.lng
      ),
      zoom: 10,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    this.map = new google.maps.Map(
      this.mapElement.nativeElement,
      mapProperties
    );

    this.addMarkers();
  }

  addMarkers() {
    let localmap = this.map;
    var counter = 1;
    this.memberLocArr.forEach((a) => {
      var marker1 = new google.maps.Marker({
        position: new google.maps.LatLng(a.latitude, a.longitude),
        label: counter.toString(),
        map: this.map,
      });
      var dynamicContent =
        '<div class="mr-1"><br><h6>' +
        a.firstName +
        ' ' +
        a.lastName +
        '</h6>' +
        '<div>' +
        a.street +
        '</div>' +
        '<div>' +
        a.city +
        ', ' +
        a.state +
        ' ' +
        a.zip +
        '</div> <br>' +
        '<div class="text-center"><button class="btn btn-small btn-primary px-2 py-0" onclick="' +
        this.googleUrl(a) +
        '"' +
        '><small>Directions</small></button></div><br></div>';

      var infowindow1 = new google.maps.InfoWindow({
        content: dynamicContent,
        maxWidth: 350,
      });
      marker1.addListener('click', () => {
        infowindow1.set('anchor', marker1);
        infowindow1.open(localmap);
        infowindow1.set('shouldFocus', false);
      });
      counter = counter + 1;
    });
  }

  googleUrl(member: any) {
    // var wazeRoute: string = encodeURI(
    //   'https://waze.com/ul?q=' + member.address
    // );
    var googleRoute: string = encodeURI(
      "window.location.href='https://www.google.com/maps?daddr=" +
        member.street +
        ' ' +
        member.city +
        ', ' +
        member.state +
        ' ' +
        member.zip +
        "'"
    );

    return googleRoute;
  }

  // wazeUrl(member: MemberLocation) {
  //   var result: string =
  //     'window.location.href=' +
  //     // +'https://www.google.com/maps?saddr=Your+Location&daddr=' +
  //     "'https://waze.com/ul?q=" +
  //     member.street +
  //     ' ' +
  //     member.city +
  //     ', ' +
  //     member.state +
  //     ' ' +
  //     member.zip +
  //     "'";
  //   return encodeURI(result);
  // }
}
